module.exports = __webpack_public_path__ + "media/PGetsWoke.a1e234ab.mp4";